import React, { Suspense } from 'react';

const LoadableComponent = React.lazy(() => import('./ResetPassword'));

function LoadableResetPassword() {
  return (
    <Suspense fallback={<div />}>
      <LoadableComponent />
    </Suspense>
  );
}

export default LoadableResetPassword;

